import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import {
  get,
  size,
  debounce,
  uniqBy,
  forEach,
  filter,
  includes,
  toString,
  toLower,
} from "lodash";

import { fetchPost } from "../../api/fetch";

import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";

import CustomInput from "../Common/CustomInput";
import ProfileSearchResults from "./ProfilesSearchResults";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  inputAdornment: {
    backgroundColor: colors.white,
    cursor: "pointer",
  },
};

const ProfilesSearch = (props) => {
  const { classes, language } = props;
  const [searchValue, setSearchValue] = React.useState("");
  const [profilesResults, setProfilesResults] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    if (size(newValue) > 2) {
      debouncedSearch(newValue, setIsFetching);
    }
  };

  const debouncedSearch = React.useCallback(
    debounce(async (searchValue, setIsFetching) => {
      setIsFetching(true);
      try {
        let res = await fetchPost("profiles/search", {
          search_text: searchValue,
        });
        res = uniqBy(res, (item) => get(item, ["id"]));
        forEach(res, (item) => {
          // Profile photo
          item.photo = get(
            filter(
              get(item, ["images"]),
              (img) =>
                img.active &&
                (get(item, ["type", "id"]) !== 1 ||
                  get(img, ["enrollment_status"]))
            ),
            [0, "url"]
          );
          // String Found & attribute
          let stringFound, attribute, attributeId;
          forEach(get(item, ["attributes"]), (attr) => {
            if (
              includes(
                toLower(toString(get(attr, ["value"]))),
                toLower(searchValue)
              )
            ) {
              stringFound = get(attr, ["value"]);
              attribute = get(attr, [`name_${language}`]);
              attributeId = get(attr, ["id"]);
            }
          });
          item.stringFound = stringFound;
          item.attribute = attribute;
          item.attributeId = attributeId;
        });
        setProfilesResults(res);
      } catch (e) {
        console.log(e);
      }
      setIsFetching(false);
    }, 500),
    []
  );

  const cleanSearchedProfiles = () => {
    setSearchValue("");
    setProfilesResults();
  };

  return (
    <Box style={{ width: "300px", position: "relative" }}>
      <CustomInput
        name="name"
        value={searchValue}
        onChange={handleChange}
        startAdornment={<img src={images.searchIcon} alt="search" />}
        endAdornment={
          isFetching ? (
            <InputAdornment
              position="end"
              classes={{ root: classes.inputAdornment }}
            >
              <CircularProgress size={14} />
            </InputAdornment>
          ) : searchValue ? (
            <InputAdornment
              position="end"
              classes={{ root: classes.inputAdornment }}
            >
              <img
                src={images.closeIcon}
                alt="clean"
                onClick={cleanSearchedProfiles}
                width="12px"
                height="12px"
              />
            </InputAdornment>
          ) : null
        }
      />
      {!isFetching && size(searchValue) > 2 && (
        <ProfileSearchResults
          profiles={profilesResults}
          searchValue={searchValue}
          language={language}
          isFetching={isFetching}
          style={{
            position: "absolute",
            top: 36,
            left: 0,
          }}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfilesSearch));
